import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import {
    ShaftCompleteButtonContainer,
    HaneCompleteButtonContainer,
    WashiCompleteButtonContainer,
    KebikiCompleteButtonContainer,
    HazuCompleteButtonContainer,
    YajiriCompleteButtonContainer,
    YashakuCompleteButtonContainer,
    HonsuCompleteButtonContainer,
    InsertCompleteButtonContainer,
    HazumakiCompleteButtonContainer,
    RameCompleteButtonContainer,
    KokuinCompleteButtonContainer,
    KamonCompleteButtonContainer,
    TypeZeroCompleteButtonContainer,
    DecorationCompleteButtonContainer,
    FeatherinsideCompleteButtonContainer,
} from '@container/PartsButton';
import { useMediaMobile } from '@app/react/common/useMedia';
import { Props } from './props';
import { selectPreviewMode } from './selector';

export type KintekiFullComponentProps = Props;

export const KintekiFullComponent: FC<KintekiFullComponentProps> = (props) => {
    const { visible, enablePreviewMode } = props;

    const isMobile = useMediaMobile();
    const isPreviewMode = useSelector(selectPreviewMode);
    const enabled = useMemo(() => isMobile && isPreviewMode, [
        isMobile,
        isPreviewMode,
    ]);

    const rootClassName = classNames('order-parts-select', {
        hidden: !visible,
        'current-3d-view': enablePreviewMode,
    });

    return (
        <div className={rootClassName}>
            <ShaftCompleteButtonContainer />
            <HaneCompleteButtonContainer even={enabled} />
            <WashiCompleteButtonContainer />
            <KebikiCompleteButtonContainer even={enabled} />
            <HazuCompleteButtonContainer />
            <YajiriCompleteButtonContainer even={enabled} />
            <YashakuCompleteButtonContainer />
            <HonsuCompleteButtonContainer even={enabled} />
            <InsertCompleteButtonContainer />
            <HazumakiCompleteButtonContainer even={enabled} />
            <RameCompleteButtonContainer />
            <KokuinCompleteButtonContainer even={enabled} />
            <KamonCompleteButtonContainer />
            <FeatherinsideCompleteButtonContainer even={enabled} />
            <DecorationCompleteButtonContainer />
            <TypeZeroCompleteButtonContainer even={enabled} />
        </div>
    );
};
